<template lang="pug">
  .component-backoffice-coupon-in-use-list
    .row
      .column.small-2.large-2
        selectize-driver(@optionSelected="selectDriver" @optionRemoved="unsetDriverId" :allowEmptyOption="true")
      .column.small-4.large-2
        select(v-model="searchRequest.coupon_code")
          option(value="") Search for code
          option(v-for="(option, index) in options" :value="option.code") {{ option.code }}
      .column.shrink
        date-range-picker.rightMargin(@input="dateRangeSelected" :key = "componentKey" label="Select created range")
      .column
        a.fa.fa-filter.fa-2x(@click="searchFilter")
    .row
      .column
        base-list(:component="component", :dataLoader="dataLoader", :search="search" :showPerPageSelect="true", ref="list")
</template>

<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import BaseList from './BaseList'
import SelectizeDriver from "../../components/structure/ui/lists/selectize/SelectizeDriver";
import DateRangePicker from "../../components/structure/DateRangePicker";

export default {
  name: 'CouponInUseList',
  components: {
    DateRangePicker,
    SelectizeDriver,
    BaseList,
  },
  data: function () {
    return {
      component: require('src/components/backoffice/CouponInUse.vue'),
      searchRequest: {
        driver_id: '',
        coupon_code: '',
        from: '',
        to: ''
      },
      search: null,
      componentKey: 0,
      pickerLabel: "Select created range",
      options: null,
    }
  },
  mounted() {
    this.couponsLoader()
  },

  methods: {
    couponsLoader(callback, page = 1, resultsPerPage = 25,) {
      KeplerBackofficeSdk.coupons.list(page, resultsPerPage).all((data) => {
        this.options = data.items
      })
    },
    dataLoader(callback, page = 1, resultsPerPage = 25, body = this.searchRequest) {
      KeplerBackofficeSdk.coupons.list(page, resultsPerPage, body).list((data) => {
        callback(data);
      })

      this.searchRequest = {
        from: '',
        to: ''
      }
    },
    selectDriver(obj) {
      this.searchRequest.driver_id = obj.id
    },
    unsetDriverId() {
      this.search.driver_id = null
    },
    dateRangeSelected(range) {
      this.searchRequest.from = range.start
      this.searchRequest.to = range.end
    },
    searchFilter() {
      this.search = this.searchRequest
    }
  },

}
</script>

<style lang="sass" rel="stylesheet/sass">

.rightMargin
  margin-left: 25px

</style>



// WEBPACK FOOTER //
// CouponInUseList.vue?524bc3a0